<template>
    <div>
        <h1 class="display-heading">Practice Profile</h1>
        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                        <b>User Details</b>
                    </div>
                <div class="row">
                    <div class="form-group required col-12 col-lg-6">
                        <label>Email</label>
                        <input type="text" name="email" data-vv-validate-on="blur" data-vv-as="email"
                            placeholder="Email" v-model="email" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('email')
                        }">
                        <div v-show="validationErrors.has('email')" class="invalid-feedback">
                            {{ validationErrors.first('email') }}
                        </div>
                    </div>
                    <div class="form-group required col-12 col-lg-6">
                        <label>Phone Number</label>
                        <input type="text" name="phone" data-vv-validate-on="blur" data-vv-as="phone"
                            placeholder="Phone" v-model="phone" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('phone')
                        }">
                        <div v-show="validationErrors.has('phone')" class="invalid-feedback">
                            {{ validationErrors.first('phone') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>General Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Practice Name</label>
                            <input type="text" name="name" data-vv-validate-on="blur" data-vv-as="name"
                                placeholder="Practice Name" v-model="name" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('name')
                            }">
                            <div v-show="validationErrors.has('name')" class="invalid-feedback">
                                {{ validationErrors.first('name') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Languages Speak</label>
                            <input style="opacity:0;" :class="{ 'is-invalid':  languagesSpeakHasError }">
                            <div v-show="languagesSpeakHasError" class="invalid-feedback mb-2">
                                The languages speak field is required.
                            </div>
                            <div class="row">
                                <div class="col-6 not-required" v-for="language in languages" :key="language">
                                    <input type="checkbox" :id="language" :value="language" v-model="languagesSpeak">
                                    <label class="ml-2" :for="language">{{ language }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if="false">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Bank Account Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Bank Account Payee Name</label>
                            <input type="text" name="bankAccountPayeeName" data-vv-validate-on="blur" data-vv-as="bank account payee name"
                                placeholder="Bank Account Payee Name" v-model="bankAccountPayeeName" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankAccountPayeeName')
                            }">
                            <div v-show="validationErrors.has('bankAccountPayeeName')" class="invalid-feedback">
                                {{ validationErrors.first('bankAccountPayeeName') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Bank Name</label>
                            <input type="text" name="bankName" data-vv-validate-on="blur" data-vv-as="bank name"
                                placeholder="Bank Name" v-model="bankName" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankName')
                            }">
                            <div v-show="validationErrors.has('bankName')" class="invalid-feedback">
                                {{ validationErrors.first('bankName') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Bank Account Number</label>
                            <input type="text" name="bankAccountNumber" data-vv-validate-on="blur" data-vv-as="bank account number"
                                placeholder="Bank Account Number" v-model="bankAccountNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankAccountNumber')
                            }">
                            <div v-show="validationErrors.has('bankAccountNumber')" class="invalid-feedback">
                                {{ validationErrors.first('bankAccountNumber') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Optometrist Details</b>
                </div>
                <div class="row">
                    <div class="form-group required col-12 col-lg-6">
                        <label>Full Name</label>
                        <input type="text" name="optoFullName" data-vv-validate-on="blur" data-vv-as="full name"
                            placeholder="Full Name" v-model="optoFullName" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('optoFullName')
                        }">
                        <div v-show="validationErrors.has('optoFullName')" class="invalid-feedback">
                            {{ validationErrors.first('optoFullName') }}
                        </div>
                    </div>
                    <div class="form-group required col-12 col-lg-6">
                        <label>Qualification</label>
                        <input type="text" name="optoQualification" data-vv-validate-on="blur" data-vv-as="qualification"
                            placeholder="Qualification" v-model="optoQualification" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('optoQualification')
                        }">
                        <div v-show="validationErrors.has('optoQualification')" class="invalid-feedback">
                            {{ validationErrors.first('optoQualification') }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group required col-12">
                        <label>Awarding Institution</label>
                        <input type="text" name="optoAwardingInstitution" data-vv-validate-on="blur" data-vv-as="awarding institution"
                            placeholder="Awarding Institution" v-model="optoAwardingInstitution" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('optoAwardingInstitution')
                        }">
                        <div v-show="validationErrors.has('optoAwardingInstitution')" class="invalid-feedback">
                            {{ validationErrors.first('optoAwardingInstitution') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Contact Details</b>
                    <div class="row">
                        <div class="form-group required col-12 col-lg-3">
                            <label>Contact Person Designation</label>
                            <input type="text" name="contactPersonDesignation" data-vv-validate-on="blur" data-vv-as="contact person designation"
                                placeholder="E.g. Mr., Mrs, Dr., Dato Sri" v-model="contactPersonDesignation" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('contactPersonDesignation')
                            }">
                            <div v-show="validationErrors.has('contactPersonDesignation')" class="invalid-feedback">
                                {{ validationErrors.first('contactPersonDesignation') }}
                            </div>
                        </div>

                        <div class="form-group required col-12 col-lg-9">
                            <label>Contact Person</label>
                            <input type="text" name="contactPerson" data-vv-validate-on="blur" data-vv-as="contact person"
                                placeholder="Contact Person" v-model="contactPerson" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('contactPerson')
                            }">
                            <div v-show="validationErrors.has('contactPerson')" class="invalid-feedback">
                                {{ validationErrors.first('contactPerson') }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group required col-12 col-lg-6">
                            <label>Practice Phone</label>
                            <input type="text" name="clinicPhone" data-vv-validate-on="blur" data-vv-as="practice phone"
                                placeholder="Practice Phone" v-model="clinicPhone" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicPhone')
                            }">
                            <div v-show="validationErrors.has('clinicPhone')" class="invalid-feedback">
                                {{ validationErrors.first('clinicPhone') }}
                            </div>
                        </div>

                        <div class="form-group required col-12 col-lg-6">
                            <label>Practice Email</label>
                            <input type="text" name="clinicEmail" data-vv-validate-on="blur" data-vv-as="practice email"
                                placeholder="Practice Email" v-model="clinicEmail" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicEmail')
                            }">
                            <div v-show="validationErrors.has('clinicEmail')" class="invalid-feedback">
                                {{ validationErrors.first('clinicEmail') }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-12 col-lg-6">
                            <label>Fax</label>
                            <input type="text" name="fax" data-vv-validate-on="blur" data-vv-as="fax"
                                placeholder="Fax" v-model="fax" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('fax')
                            }">
                            <div v-show="validationErrors.has('fax')" class="invalid-feedback">
                                {{ validationErrors.first('fax') }}
                            </div>
                        </div>

                        <div class="form-group col-12 col-lg-6">
                            <label>Website</label>
                            <input type="text" name="website" data-vv-validate-on="blur" data-vv-as="website"
                                placeholder="Website" v-model="website" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('website')
                            }">
                            <div v-show="validationErrors.has('website')" class="invalid-feedback">
                                {{ validationErrors.first('website') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Location Details</b>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="place-map">
                            <div class="mb-2">
                                <p>Adjust red marker to desired location.</p>
                                <p class="text-danger">Click "Get Location" to retrieve latitude and longitude.</p>
                            </div>
                            <div class="place-gmaps-wrapper">
                                <div :id="mapId" class="google-map" :style="
                                {
                                    height:`${mapHeight}px`
                                }">
                                </div>
                                <div class="map-search-wrapper">
                                    <div class="input-group">
                                        <input :id="searchBoxId" type="text" class="form-control mr-1" placeholder="Search location"
                                        v-model="currentAddress">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" @click="getGmapLatLng">
                                                Get Location
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="map-edit-cursor"
                                    :style="cursorPosition">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="row">
                            <div class="col-12 font-italic font-weight-bold" style="font-size: 14px;">
                                Please confirm your Geolocation
                            </div>
                            <div class="form-group required col-12 col-md-6">
                                <label>Latitude</label>
                                <input disabled type="text" name="lat" data-vv-validate-on="blur" data-vv-as="latitude"
                                    placeholder="Latitude" v-model="lat" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('lat')
                                }">
                                <div v-show="validationErrors.has('lat')" class="invalid-feedback">
                                    {{ validationErrors.first('lat') }}
                                </div>
                            </div>

                            <div class="form-group required col-12 col-md-6">
                                <label>Longitude</label>
                                <input disabled type="text" name="long" data-vv-validate-on="blur" data-vv-as="longitude"
                                    placeholder="Longitude" v-model="long" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('long')
                                }">
                                <div v-show="validationErrors.has('long')" class="invalid-feedback">
                                    {{ validationErrors.first('long') }}
                                </div>
                            </div>
                        </div>

                        <div class="font-weight-bold font-italic" style="font-size: 14px; color:red;">
                            Please fill up
                        </div>

                        <div class="form-group required">
                            <label>Address Line 1</label>
                            <input type="text" name="addressLine1" data-vv-validate-on="blur" data-vv-as="address line 1"
                                placeholder="Address Line 1" v-model="addressLine1" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressLine1')
                            }">
                            <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine1') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Address Line 2</label>
                            <input type="text" name="addressLine2" data-vv-validate-on="blur" data-vv-as="address line 2"
                                placeholder="Address Line 2" v-model="addressLine2" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressLine2')
                            }">
                            <div v-show="validationErrors.has('addressLine2')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine2') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>City</label>
                            <input type="text" name="addressCity" data-vv-validate-on="blur" data-vv-as="address city"
                                placeholder="City" v-model="addressCity" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressCity')
                            }">
                            <div v-show="validationErrors.has('addressCity')" class="invalid-feedback">
                                {{ validationErrors.first('addressCity') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>State</label>
                            <input type="text" name="addressState" data-vv-validate-on="blur" data-vv-as="address state"
                                placeholder="State" v-model="addressState" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressState')
                            }">
                            <div v-show="validationErrors.has('addressState')" class="invalid-feedback">
                                {{ validationErrors.first('addressState') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Postcode</label>
                            <input type="text" name="addressPoscode" data-vv-validate-on="blur" data-vv-as="address postcode"
                                placeholder="Postcode" v-model="addressPoscode" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressPoscode')
                            }">
                            <div v-show="validationErrors.has('addressPoscode')" class="invalid-feedback">
                                {{ validationErrors.first('addressPoscode') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Operating Hours</b>
                    <div v-show="workingDaysHasError" class="text-danger">The operating hours field is required.</div>
                </div>
                <input style="opacity:0;" :class="{ 'is-invalid':  workingDaysHasError }">
                <div class="row">
                    <div class="form-group d-flex justify-content-between col-12 col-lg-6" v-for="workingDay in workingDays" :key="workingDay.workingDayId">
                        <div class="">
                            <input class="mr-2" type="checkbox" :id="workingDay.text" :value="workingDay.workingDayId" v-model="workingDay.selected">
                            <label :for="workingDay.text">{{ workingDay.text }}</label>
                        </div>
                        <div class="">
                            <vue-timepicker
                                :disabled="workingDay.selected === false"
                                format="hh:mm A"
                                v-model="workingDay.startTime"
                                hide-clear-button
                                class="ml-2 mr-2"
                            >
                            </vue-timepicker>
                            to
                            <vue-timepicker
                                :disabled="workingDay.selected === false"
                                format="hh:mm A"
                                class="ml-2 mr-2"
                                v-model="workingDay.endTime"
                                hide-clear-button
                            >
                            </vue-timepicker>
                        </div>
                    </div>
                </div>
                <div class="form-group mt-2">
                    <label>Operating Hours Special Remarks (Optional)</label>
                    <input type="text" placeholder="Operating Hours Special Remarks (Optional)" v-model="operatingHoursRemarks" class="form-control">
                    <small>E.g.: Lunch hours 12pm - 2pm</small>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Facilities & Services</b>
                </div>

                <div class="form-group">
                    <div class="row">
                        <div class="col-6 d-flex align-items-start" v-for="facilityAndServiceOption in facilitiesAndServicesOptions" :key="facilityAndServiceOption">
                            <input type="checkbox" :id="facilityAndServiceOption" :value="facilityAndServiceOption" v-model="facilitiesAndServices" class="mt-1">
                            <label class="ml-2 mb-0" :for="facilityAndServiceOption">{{ facilityAndServiceOption }}</label>
                        </div>
                    </div>

                    <div class="form-group mt-2">
                        <label>Others Tests (Please Specify)</label>
                        <input type="text" name="otherFacilitiesAndServices" data-vv-validate-on="blur" data-vv-as="other facilities and services" placeholder="E.g. Color Vision Testing" v-model="otherFacilitiesAndServices" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('otherFacilitiesAndServices')
                        }">
                        <small>Separate by a comma (,)</small>
                        <div v-show="validationErrors.has('otherFacilitiesAndServices')" class="invalid-feedback">
                            {{ validationErrors.first('otherFacilitiesAndServices') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Practice Registration (SSM)</b>
                        </div>
                        <div class="form-group">
                            <label>Practice Registration (SSM) Number</label>
                            <input type="text" name="clinicRegistrationNumber" data-vv-validate-on="blur" data-vv-as="Practice Registration (SSM) Number"
                                placeholder="Practice Registration (SSM) Number" v-model="clinicRegistrationNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicRegistrationNumber')
                            }">
                            <div v-show="validationErrors.has('clinicRegistrationNumber')" class="invalid-feedback">
                                {{ validationErrors.first('clinicRegistrationNumber') }}
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="mb-3">
                                <b>Uploaded Document</b>

                                <div v-if="!!ssmUploadResponse.docFileNameGUID">
                                    <p>{{ssmUploadResponse.docOriFileName}}</p>
                                    <div>
                                        <a :href="`${clinicSupportingDocumentPath}${ssmUploadResponse.docFileNameGUID}`"
                                            class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                                    </div>
                                </div>
                                <div v-else class="font-italic">None</div>
                            </div>

                            <div>
                                <b>Update Document</b>
                                <clinic-supporting-document-uploader
                                    uploadButtonText="Update Document"
                                    uploadFileName="SSM document"
                                    uploadApiUrl="Profile/ClinicUploadSupportingDocument"
                                    uploadApiFileParameter="DocumentFile"
                                    :uploadApiAdditionalParameters="[{'name': 'DocumentType', 'value': 1}]"
                                    @fileUploaded="updateformSSMDocumentDetails">
                                </clinic-supporting-document-uploader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>AMO Membership Number</b>
                        </div>
                        <div class="form-group required">
                            <label>AMO Membership Number</label>
                            <input type="text" name="optoAmoMembershipNumber" data-vv-validate-on="blur" data-vv-as="AMO membership number"
                                placeholder="AMO Membership Number" v-model="optoAmoMembershipNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('optoAmoMembershipNumber')
                            }">
                            <div v-show="validationErrors.has('optoAmoMembershipNumber')" class="invalid-feedback">
                                {{ validationErrors.first('optoAmoMembershipNumber') }}
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="mb-3">
                                <b>Uploaded Document</b>

                                <div v-if="!!optoAmoUploadResponse.docFileNameGUID">
                                    <p>{{optoAmoUploadResponse.docOriFileName}}</p>
                                    <div>
                                        <a :href="`${clinicSupportingDocumentPath}${optoAmoUploadResponse.docFileNameGUID}`"
                                            class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                                    </div>
                                </div>
                                <div v-else class="font-italic">None</div>
                            </div>

                            <div>
                                <b>Update Document</b>
                                <clinic-supporting-document-uploader
                                    uploadButtonText="Update Document"
                                    uploadFileName="AMO membership document"
                                    uploadApiUrl="Profile/ClinicUploadSupportingDocument"
                                    uploadApiFileParameter="DocumentFile"
                                    :uploadApiAdditionalParameters="[{'name': 'DocumentType', 'value': 5}]"
                                    @fileUploaded="updateformAmoDocumentDetails">
                                </clinic-supporting-document-uploader>
                                <div v-show="optoAmoDocumentHasError" class="text-danger small mt-1">
                                    AMO membership document is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Malaysian Optical Council (MOC) Registration Number</b>
                        </div>
                        <div class="form-group required">
                            <label>Malaysian Optical Council (MOC) Registration Number</label>
                            <input type="text" name="optoMalaysiaOpticalCouncilRegistrationNumber" data-vv-validate-on="blur" data-vv-as="Malaysian Optical Council (MOC) registration number"
                                placeholder="Registration Number" v-model="optoMalaysiaOpticalCouncilRegistrationNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('optoMalaysiaOpticalCouncilRegistrationNumber')
                            }">
                            <div v-show="validationErrors.has('optoMalaysiaOpticalCouncilRegistrationNumber')" class="invalid-feedback">
                                {{ validationErrors.first('optoMalaysiaOpticalCouncilRegistrationNumber') }}
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="mb-3">
                                <b>Uploaded Document</b>

                                <div v-if="!!optoMocUploadResponse.docFileNameGUID">
                                    <p>{{optoMocUploadResponse.docOriFileName}}</p>
                                    <div>
                                        <a :href="`${clinicSupportingDocumentPath}${optoMocUploadResponse.docFileNameGUID}`"
                                            class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                                    </div>
                                </div>
                                <div v-else class="font-italic">None</div>
                            </div>

                            <div>
                                <b>Update Document</b>
                                <clinic-supporting-document-uploader
                                    uploadButtonText="Update Document"
                                    uploadFileName="MOC registration document"
                                    uploadApiUrl="Profile/ClinicUploadSupportingDocument"
                                    uploadApiFileParameter="DocumentFile"
                                    :uploadApiAdditionalParameters="[{'name': 'DocumentType', 'value': 6}]"
                                    @fileUploaded="updateformMocDocumentDetails">
                                </clinic-supporting-document-uploader>
                                <div v-show="optoMocDocumentHasError" class="text-danger small mt-1">
                                    MOC registration document is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-2">
            <p v-show="isSubmitMessageShown" :class="{
                'text-danger': isSubmitMessageError
            }">
                {{submitMessage}}
            </p>
        </div>

        <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="saveProfile">
            Save Changes
        </button>
        <button type="button" class="btn btn-secondary" @click="getProfile">Cancel Changes</button>
    </div>
</template>

<script>
/* global google */
import {
    apiPath
} from '@/config';
import { googleMapsConfig } from '@/config/';
import { generateRandomId } from '@/utilities/';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import facilitiesAndServicesOptions from '@/config/optometristFacilitiesAndServices';
import languages from '@/config/languages';
import changePassword from '@/components/change-password';
import ClinicSupportingDocumentUploader from '@/components/file-uploader/clinic-supporting-document-uploader';
import {
    mask
} from 'vue-the-mask';

export default {
    'name': 'OptometristProfile',
    'components': {
        VueTimepicker,
        changePassword,
        ClinicSupportingDocumentUploader
    },
    'directives': {
        mask
    },
    'computed': {
        mapHeight () {
            return this.mapWidth;
        },
        cursorPosition () {
            let cursorWidth = 48;
            let tipOffset = 20;

            return {
                'left': `${(this.mapHeight / 2) - (cursorWidth / 2)}px`,
                'top': `${((this.mapHeight / 2) - (cursorWidth / 2)) - tipOffset}px`
            };
        },
        clinicSupportingDocumentPath () {
            return `${apiPath}Profile/ClinicSupportingDocument?fileName=`;
        }
    },
    data () {
        return {
            facilitiesAndServicesOptions,
            languages,
            'name': '',
            'email': '',
            'phone': '',
            'languagesSpeak': [],
            'internetProvider': '',
            'contactPerson': '',
            'contactPersonDesignation': '',
            'website': '',
            'fax': '',
            'clinicEmail': '',
            'clinicPhone': '',
            'otherFacilitiesAndServices': '',
            'facilitiesAndServices': [],
            'bankAccountNumber': '',
            'bankName': '',
            'bankAccountPayeeName': '',
            'lat': '',
            'long': '',
            'addressPoscode': '',
            'addressState': '',
            'addressCity': '',
            'addressLine1': '',
            'addressLine2': '',
            'workingDaysHasError': false,
            'languagesSpeakHasError': false,
            'workingDays': [
                {
                    'workingDayId': 1,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Monday',
                    'selected': false
                },
                {
                    'workingDayId': 2,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Tuesday',
                    'selected': false
                },
                {
                    'workingDayId': 3,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Wednesday',
                    'selected': false
                },
                {
                    'workingDayId': 4,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Thursday',
                    'selected': false
                },
                {
                    'workingDayId': 5,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Friday',
                    'selected': false
                },
                {
                    'workingDayId': 6,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Saturday',
                    'selected': false
                },
                {
                    'workingDayId': 7,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Sunday',
                    'selected': false
                }
            ],
            'operatingHoursRemarks': '',
            'clinicRegistrationNumber': '',
            'optoFullName': '',
            'optoAmoMembershipNumber': '',
            'optoQualification': '',
            'optoAwardingInstitution': '',
            'optoMalaysiaOpticalCouncilRegistrationNumber': '',
            'ssmUploadResponse': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'optoAmoUploadResponse': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'optoMocUploadResponse': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'mapId': '',
            'mapDom': null,
            'searchBoxId': '',
            'searchBoxDom': null,
            'googleMapObj': null,
            'googleMapsAutoComplete': null,
            'currentAddress': '',
            'mapWidth': '',
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': '',
            'optoAmoDocumentHasError': false,
            'optoMocDocumentHasError': false
        };
    },
    'methods': {
        validate () {
            let workingDayCount = 7;

            for (const workingDay of this.workingDays) {
                if (workingDay.selected === false) {
                    workingDayCount--;
                }
            }

            if (workingDayCount <= 0) {
                this.workingDaysHasError = true;
                return Promise.resolve(false);
            }

            if (this.languagesSpeak.length <= 0) {
                this.languagesSpeakHasError = true;
                return Promise.resolve(false);
            }

            this.optoAmoDocumentHasError = !this.optoAmoUploadResponse.docFileNameGUID;
            this.optoMocDocumentHasError = !this.optoMocUploadResponse.docFileNameGUID;

            if (this.optoAmoDocumentHasError || this.optoMocDocumentHasError) {
                return Promise.resolve(false);
            }

            return this.$validator.validateAll();
        },
        initGoogleMaps () {
            this.googleMapObj = new google.maps.Map(this.mapDOM, googleMapsConfig);

            let isValidLat = this.lat > -90 && this.lat < 90;
            let isValidLng = this.long > -180 && this.long < 180;
            if (isValidLat && isValidLng) {
                if (this.googleMapObj) {
                    this.googleMapObj.setCenter({
                        'lat': parseFloat(this.lat),
                        'lng': parseFloat(this.long)
                    });
                };
            }

            // Init search box, restrict places to Malaysia only.
            this.googleMapsAutoComplete = new google.maps.places.Autocomplete(this.searchBoxDOM);
            this.googleMapsAutoComplete.setComponentRestrictions({ 'country': 'my' });

            this.googleMapsAutoComplete.addListener('place_changed', () => {
                let place = this.googleMapsAutoComplete.getPlace();
                let placeGeometry = place.geometry;

                // this.form.searchLocation = place.name;
                if (placeGeometry) {
                    this.googleMapObj.setCenter(placeGeometry.location);
                }
            });

            this.googleMapObj.addListener('click', (event) => {
                this.googleMapObj.setCenter(event.latLng);
            });

            // Bias the SearchBox results towards current map's viewport.
            this.googleMapObj.addListener('bounds_changed', () => {
                this.googleMapsAutoComplete.setBounds(this.googleMapObj.getBounds());
            });
        },
        googleMapsResizeHandler () {
            if (this.googleMapObj) {
                google.maps.event.trigger(this.googleMapObj, 'resize');
            }
        },
        windowResizeHandler () {
            this.mapWidth = this.mapDOM.getBoundingClientRect().width;
        },
        getGmapLatLng () {
            if (this.googleMapObj) {
                let latLng = this.googleMapObj.getCenter();
                this.lat = latLng.lat();
                this.long = latLng.lng();
            }
        },
        formatCommaPayload (array) {
            let string = '';
            for (const [index, element] of array.entries()) {
                string = string + element;

                if (index !== array.length - 1) {
                    string = string + ',';
                }
            }

            return string;
        },
        getProfile () {
            this.axios.get('Profile/GetUserProfile').then(({ data }) => {
                const practice = data.data;

                this.name = practice.n;
                this.email = practice.e;
                this.phone = practice.mn;
                this.languagesSpeak = practice.ls ? practice.ls.split(',') : [];
                this.lat = parseFloat(practice.la);
                this.long = parseFloat(practice.lo);
                this.fax = practice.f;
                this.website = practice.w;
                this.addressLine1 = practice.a1;
                this.addressLine2 = practice.a2;
                this.addressCity = practice.ac;
                this.addressState = practice.as;
                this.addressPoscode = practice.ap;
                this.bankAccountPayeeName = practice.bap;
                this.bankAccountNumber = practice.ban;
                this.bankName = practice.bn;
                this.contactPerson = practice.cp;
                this.contactPersonDesignation = practice.cpd;
                this.internetProvider = practice.ip;
                this.facilitiesAndServices = practice.fas ? practice.fas.split(',') : [];
                this.clinicEmail = practice.cne;
                this.clinicPhone = practice.cnp;
                this.clinicRegistrationNumber = practice.crn;
                this.optoFullName = practice.ofn;
                this.optoAmoMembershipNumber = practice.oamn;
                this.optoQualification = practice.oq;
                this.optoAwardingInstitution = practice.oai;
                this.optoMalaysiaOpticalCouncilRegistrationNumber = practice.omocrn;

                if (practice.cssmd) {
                    this.ssmUploadResponse.docFileNameGUID = practice.cssmd.fg;
                    this.ssmUploadResponse.docOriFileName = practice.cssmd.fn;
                }

                if (practice.oamd) {
                    this.optoAmoUploadResponse.docFileNameGUID = practice.oamd.fg;
                    this.optoAmoUploadResponse.docOriFileName = practice.oamd.fn;
                }

                if (practice.omocd) {
                    this.optoMocUploadResponse.docFileNameGUID = practice.omocd.fg;
                    this.optoMocUploadResponse.docOriFileName = practice.omocd.fn;
                }

                const otherArray = this.facilitiesAndServices.filter((obj) => { return this.facilitiesAndServicesOptions.indexOf(obj) === -1; });
                this.facilitiesAndServices = this.facilitiesAndServices.filter((el) => !otherArray.includes(el));

                this.otherFacilitiesAndServices = '';
                for (const [index, otherFacilityAndService] of otherArray.entries()) {
                    this.otherFacilitiesAndServices = this.otherFacilitiesAndServices + otherFacilityAndService;

                    if (index !== otherArray.length - 1) {
                        this.otherFacilitiesAndServices = this.otherFacilitiesAndServices + ',';
                    }
                }

                for (const practiceWorkingDay of practice.wd) {
                    for (const workingDay of this.workingDays) {
                        if (parseFloat(practiceWorkingDay.workingDayId) === parseFloat(workingDay.workingDayId)) {
                            workingDay.selected = true;
                            workingDay.startTime = practiceWorkingDay.startTime;
                            workingDay.endTime = practiceWorkingDay.endTime;
                        }
                    }
                }

                this.operatingHoursRemarks = practice.ohsr;

                window.addEventListener('resize', this.windowResizeHandler);
                window.addEventListener('orientationchange', this.windowResizeHandler);

                this.mapDOM = document.getElementById(this.mapId);
                this.searchBoxDOM = document.getElementById(this.searchBoxId);
                this.mapWidth = this.mapDOM.getBoundingClientRect().width;

                this.initGoogleMaps();
            });
        },
        saveProfile () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            Promise.all([this.validate()]).then(
                (validationResults) => {
                    this.$nextTick(() => {
                        if (validationResults.filter(v => v === false).length > 0) {
                            document.body.querySelector('.is-invalid').focus();

                            this.isSubmitMessageError = true;
                            this.submitMessage = 'You have error in the form. Please check your input(s) before saving your profile.';
                        } else {
                            this.languagesSpeakHasError = false;
                            this.workingDaysHasError = false;
                            this.submitMessage = 'Saving profile...';
                            // Compile payload
                            const payload = {
                                'n': this.name,
                                'e': this.email,
                                'mn': this.phone,
                                'ip': this.internetProvider,
                                'cp': this.contactPerson,
                                'cpd': this.contactPersonDesignation,
                                'w': this.website,
                                'f': this.fax,
                                'cne': this.clinicEmail,
                                'cnp': this.clinicPhone,
                                'ban': this.bankAccountNumber,
                                'bn': this.bankName,
                                'bap': this.bankAccountPayeeName,
                                'la': this.lat,
                                'lo': this.long,
                                'ap': this.addressPoscode,
                                'as': this.addressState,
                                'ac': this.addressCity,
                                'a1': this.addressLine1,
                                'a2': this.addressLine2,
                                'wd': this.workingDays.filter(workingDay => workingDay.selected === true),
                                'ohsr': this.operatingHoursRemarks,
                                'crn': this.clinicRegistrationNumber,
                                'ofn': this.optoFullName,
                                'oamn': this.optoAmoMembershipNumber,
                                'oq': this.optoQualification,
                                'oai': this.optoAwardingInstitution,
                                'omocrn': this.optoMalaysiaOpticalCouncilRegistrationNumber
                            };

                            // Facilities and Services
                            let facilitiesAndServices = '';
                            if (this.facilitiesAndServices.length !== 0) {
                                for (const [index, facilitiyAndService] of this.facilitiesAndServices.entries()) {
                                    facilitiesAndServices = facilitiesAndServices + facilitiyAndService;

                                    if (index !== this.facilitiesAndServices.length - 1) {
                                        facilitiesAndServices = facilitiesAndServices + ',';
                                    }
                                }
                                if (this.otherFacilitiesAndServices) {
                                    facilitiesAndServices = facilitiesAndServices + ',' + this.otherFacilitiesAndServices;
                                }
                            } else {
                                if (this.otherFacilitiesAndServices) {
                                    facilitiesAndServices = this.otherFacilitiesAndServices;
                                }
                            }

                            payload.fas = facilitiesAndServices;

                            // Language
                            payload.ls = this.formatCommaPayload(this.languagesSpeak);

                            this.axios.post('Clinic/UpdateClinicProfile', payload).then(({ data }) => {
                                this.submitMessage = 'Successfully updated profile! Your information is saved and encrypted.';
                            }).catch((error) => {
                                this.isSubmitMessageError = true;
                                if (error.response.data) {
                                    this.submitMessage = error.response.data.message;
                                } else {
                                    this.submitMessage = 'Error saving profile. Please try again.';
                                }
                            });
                        }
                    });
                });
        },
        updateformSSMDocumentDetails (documentDetails) {
            this.ssmUploadResponse.docFileNameGUID = documentDetails.fileNameGuid;
            this.ssmUploadResponse.docOriFileName = documentDetails.fileName;
        },
        updateformAmoDocumentDetails (documentDetails) {
            this.optoAmoUploadResponse.docFileNameGUID = documentDetails.fileNameGuid;
            this.optoAmoUploadResponse.docOriFileName = documentDetails.fileName;
        },
        updateformMocDocumentDetails (documentDetails) {
            this.optoMocUploadResponse.docFileNameGUID = documentDetails.fileNameGuid;
            this.optoMocUploadResponse.docOriFileName = documentDetails.fileName;
        }
    },
    'watch': {
        mapHeight () {
            this.$nextTick(() => {
                this.googleMapsResizeHandler();
            });
        }
    },
    created () {
        this.mapId = generateRandomId();
        this.searchBoxId = generateRandomId();
    },
    mounted () {
        this.getProfile();
    },
    destroyed () {
        window.removeEventListener('resize', this.windowResizeHandler);
        window.removeEventListener('orientationchange', this.windowResizeHandler);
    }

};
</script>

<style scoped>
/*Place Detail*/
.place-map
{
    margin-bottom: 1rem;
}

.place-map > .place-gmaps-wrapper {
    position: relative;
}

.place-map .map-search-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 1em 1em 0 1em;
}

.place-map .map-edit-cursor {
    position: absolute;
    top: 0;
    width: 48px;
    height: 48px;
    background-image: url("../../assets/img/icons/location_edit.svg");
    background-size: 48px 48px;
    background-position: top left;
    background-repeat: no-repeat;
}
/*Place Detail*/

</style>
